import { Avatar, Box, Tooltip } from '@mui/material';
import React from "react";

// Paletas de colores pastel y saturados
const pastelColors = [
    '#FFD6E0', '#D6EFFF', '#FFF5D6', '#D6FFD6', '#F3D6FF', '#FFF0D6', '#D6FFF6', '#F6FFD6', '#FFD6F6', '#D6F6FF'
];
const saturatedColors = [
    '#E91E63', '#2196F3', '#FF9800', '#4CAF50', '#9C27B0', '#FFEB3B', '#00BCD4', '#8BC34A', '#FF5722', '#3F51B5'
];

function getInitials(name) {
    return name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase();
}

function getRandomColor(arr, idx) {
    // Deterministic by index for consistency
    return arr[idx % arr.length];
}

const AvatarGroupStacked = ({ users_photo_links = [], usernames = [], maxAvatars = 3, useRandomColors = true }) => {
    const avatarsToShow = usernames.slice(0, maxAvatars);
    const extraCount = usernames.length - maxAvatars;
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0 }}>
            {avatarsToShow.map((user, idx) => {
                const pastel = useRandomColors ? getRandomColor(pastelColors, idx) : '#bdbdbd';
                const sat = useRandomColors ? getRandomColor(saturatedColors, idx) : '#333';
                const photo_link = users_photo_links[idx] || user;
                return (
                    <Tooltip title={user} arrow key={user + idx}>
                        <Avatar
                            src={photo_link}
                            sx={{
                                width: 20,
                                height: 20,
                                fontSize: 11,
                                bgcolor: photo_link ? undefined : pastel,
                                color: photo_link ? undefined : sat,
                                border: '1.5px solid #fff',
                                ml: idx === 0 ? 0 : -1.2,
                                zIndex: idx + 1,
                            }}
                        >
                            {!photo_link && getInitials(user)}
                        </Avatar>
                    </Tooltip>
                );
            })}
            {extraCount > 0 && (
                <Tooltip title={`${extraCount} more users have this achievement`} arrow>
                    <Avatar sx={{ width: 20, height: 20, fontSize: 11, bgcolor: '#e0e0e0', color: '#333', border: '1.5px solid #fff', ml: avatarsToShow.length === 0 ? 0 : -1.2, zIndex: avatarsToShow.length + 2 }}>
                        +{extraCount}
                    </Avatar>
                </Tooltip>
            )}
        </Box>
    );
};

export default AvatarGroupStacked; 